import { MobileOpenClassSessionParticipant } from '../types/OpenClassSession';

export const countUnrecordedAttendance = (
  participants: MobileOpenClassSessionParticipant[],
): number =>
  participants.filter(
    ({ attendanceStatus }) => attendanceStatus === 'not_recorded',
  ).length;

export const sortParticipantsByCompany = (
  participants: MobileOpenClassSessionParticipant[],
): MobileOpenClassSessionParticipant[] =>
  [...participants].sort(
    (first, second) =>
      (first.clientCompany?.name ?? '').localeCompare(
        second.clientCompany?.name ?? '',
      ) ||
      first.name.localeCompare(second.name) ||
      first.attendeeId - second.attendeeId,
  );
